/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesCrossPlaySendInGameEventRequest
 */
export interface FxIdWebFeaturesCrossPlaySendInGameEventRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesCrossPlaySendInGameEventRequest
     */
    GameSystemName: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesCrossPlaySendInGameEventRequest
     */
    EventCode: string;
    /**
     * 
     * @type {number}
     * @memberof FxIdWebFeaturesCrossPlaySendInGameEventRequest
     */
    Value: number;
}

/**
 * Check if a given object implements the FxIdWebFeaturesCrossPlaySendInGameEventRequest interface.
 */
export function instanceOfFxIdWebFeaturesCrossPlaySendInGameEventRequest(value: object): value is FxIdWebFeaturesCrossPlaySendInGameEventRequest {
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined) return false;
    if (!('EventCode' in value) || value['EventCode'] === undefined) return false;
    if (!('Value' in value) || value['Value'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesCrossPlaySendInGameEventRequestFromJSON(json: any): FxIdWebFeaturesCrossPlaySendInGameEventRequest {
    return FxIdWebFeaturesCrossPlaySendInGameEventRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesCrossPlaySendInGameEventRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesCrossPlaySendInGameEventRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'GameSystemName': json['GameSystemName'],
        'EventCode': json['EventCode'],
        'Value': json['Value'],
    };
}

export function FxIdWebFeaturesCrossPlaySendInGameEventRequestToJSON(json: any): FxIdWebFeaturesCrossPlaySendInGameEventRequest {
    return FxIdWebFeaturesCrossPlaySendInGameEventRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesCrossPlaySendInGameEventRequestToJSONTyped(value?: FxIdWebFeaturesCrossPlaySendInGameEventRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'GameSystemName': value['GameSystemName'],
        'EventCode': value['EventCode'],
        'Value': value['Value'],
    };
}

